const zh = {
  "nav.chefs": "我们的主厨",
  "nav.experiences": "尊享体验",
  "nav.privateDining": "私人晚宴",
  "nav.journal": "美食志",
  "nav.howItWorks": "如何运作",
  "nav.events": "活动定制",
  "nav.corporate": "企业服务",
  "nav.bespoke": "私人定制",
  "nav.giftCards": "礼品卡",
  "nav.becomeChef": "成为主厨",
  "nav.about": "关于我们",
  "nav.contact": "联系我们",
  "nav.faq": "常见问题",
  "nav.login": "登录",
  "nav.logout": "退出登录",
  "nav.account": "我的账户",
  "nav.findChef": "寻找我的主厨",
  "nav.more": "更多",
  "hero.line1": "非凡美馔。",
  "hero.line2": "尽在府上。",
  "hero.sub": "经认证的私人主厨，在您的餐厅打造五星级美食体验。巴黎及更多城市。",
  "hero.badge": "私人主厨礼宾服务",
  "search.location": "城市",
  "search.date": "日期",
  "search.guests": "宾客",
  "search.cuisine": "菜系",
  "search.experience": "体验",
  "search.any": "全部",
  "search.cta": "寻找我的主厨",
  "home.featuredEyebrow": "本馆甄选",
  "home.featuredTitle": "卓越主厨",
  "home.viewAll": "探索全部主厨",
  "home.expEyebrow": "招牌体验",
  "home.expTitle": "六种非凡用餐方式",
  "home.trustEyebrow": "我们的承诺",
  "home.trustTitle": "每位主厨，严格甄选",
  "home.trustIntro": "每一枚「认证主厨」徽章背后，都是一套严格的专业审核。只有通过完整审核的主厨方可入驻——您的餐桌永远交托于行家之手。",
  "trust.i1": "身份核验（KYC）",
  "trust.i2": "职业经历审核",
  "trust.i3": "档案与作品集审核",
  "trust.i4": "厨房操作审核",
  "trust.i5": "菜品作品集标准",
  "trust.i6": "适用卫生文件",
  "trust.i7": "银行合规",
  "home.manifestoEyebrow": "宣言",
  "man.c1t": "餐桌是神圣的",
  "man.c1b": "家中的晚宴绝非外卖。它是剧场、是款待、是手艺——为您所爱之人，在您最爱的地方精心呈现。",
  "man.c2t": "匠心先于便利",
  "man.c2b": "我们的主厨清晨采买食材，在您的厨房烹饪，逐道上菜。绝无复热，绝无平庸。",
  "man.c3t": "信任，经过认证",
  "man.c3b": "Chef à Domicile 的每位主厨在端出第一道菜之前，都已通过专业认证。卓越是入门的前提。",
  "home.marquee": "巴黎私人主厨 — Chef à Domicile — 奢华私人晚宴 — 定制菜单 — 五星级款待 —",
  "home.ctaTitle": "您的餐桌值得一位主厨。",
  "home.ctaBtn": "预订体验",
  "home.journalEyebrow": "美食志",
  "home.journalTitle": "餐桌上的故事",
  "common.verified": "认证主厨",
  "common.perGuest": "每位宾客",
  "common.from": "起价",
  "common.viewProfile": "查看主页",
  "common.book": "预订",
  "common.loading": "加载中…",
  "common.error": "出现错误。",
  "common.retry": "重试",
  "common.empty": "暂无内容。",
  "common.readMore": "阅读更多",
  "common.back": "返回",
  "common.send": "发送",
  "common.sending": "发送中…",
  "common.yearsExp": "{n} 年经验",
  "common.reviews": "条评价",
  "common.languages": "语言",
  "common.all": "全部",
  "common.cancel": "取消",
  "common.save": "保存",
  "common.delete": "删除",
  "common.add": "添加",
  "common.optional": "选填",
  "common.next": "继续",
  "common.confirm": "确认",
  "common.total": "总计",
  "common.guests": "位宾客",
  "chefs.title": "认证主厨市集",
  "chefs.sub": "由我们团队认证的杰出私人主厨，随时为您上门烹饪。",
  "chefs.filters": "筛选",
  "chefs.clear": "清除筛选",
  "chefs.cuisine": "菜系",
  "chefs.city": "城市",
  "chefs.minRating": "最低评分",
  "chefs.maxPrice": "每位宾客最高价",
  "chefs.language": "主厨语言",
  "chefs.noResults": "没有符合条件的主厨。请放宽搜索条件。",
  "chefs.count": "{n} 位认证主厨",
  "chef.about": "关于主厨",
  "chef.signature": "招牌菜品",
  "chef.reviews": "宾客评价",
  "chef.bookThis": "预订这位主厨",
  "chef.qualification": "资质",
  "chef.allergens": "过敏原",
  "chef.dietary": "饮食",
  "chef.prep": "{n} 分钟备餐",
  "exp.title": "招牌体验",
  "exp.sub": "六种精选方式，将非凡美馔带回家——从私密单点晚宴到全定制美食盛会。",
  "booking.title": "预订您的体验",
  "booking.step1": "菜单",
  "booking.step2": "详情",
  "booking.step3": "确认支付",
  "booking.selectDish": "选择一道招牌菜",
  "booking.date": "日期",
  "booking.time": "时间",
  "booking.address": "地址",
  "booking.city": "城市",
  "booking.occasion": "场合",
  "booking.requests": "特殊要求",
  "booking.create": "核对我的预订",
  "booking.promo": "优惠码或礼品卡码",
  "booking.promoApply": "使用",
  "booking.promoApplied": "已使用",
  "booking.chef": "您的主厨",
  "booking.pricePerGuest": "每位宾客价格",
  "booking.pay": "前往安全支付",
  "booking.payNote": "您将被引导至 Stripe 安全支付页面。最终金额由我们的服务计算。",
  "booking.loginFirst": "请登录以完成预订。",
  "booking.stripeOff": "在线支付暂不可用。您的预订已保存——礼宾团队将与您联系完成付款。",
  "booking.discount": "优惠",
  "pay.checking": "正在确认您的付款…",
  "pay.success": "付款已确认。您的主厨已收到通知——餐桌上见。",
  "pay.failed": "付款未完成。",
  "pay.pending": "付款处理中。本页将自动更新。",
  "pay.backAccount": "查看我的预订",
  "auth.loginTitle": "欢迎回来",
  "auth.registerTitle": "创建您的账户",
  "auth.email": "邮箱",
  "auth.password": "密码",
  "auth.name": "姓名",
  "auth.loginBtn": "登录",
  "auth.registerBtn": "创建账户",
  "auth.toRegister": "初次使用？创建账户",
  "auth.toLogin": "已有账户？登录",
  "account.title": "我的账户",
  "account.bookings": "预订",
  "account.favorites": "收藏",
  "account.giftcards": "礼品卡",
  "account.dietary": "饮食档案",
  "account.addresses": "地址",
  "account.noBookings": "暂无预订。您的下一场非凡晚宴正在等候。",
  "account.noFavorites": "暂无收藏的主厨。",
  "account.status": "状态",
  "account.cancelBooking": "取消预订",
  "account.review": "撰写评价",
  "account.reviewComment": "您的评价",
  "account.messages": "消息",
  "account.writeMsg": "给您的主厨留言…",
  "account.allergies": "过敏原",
  "account.diets": "饮食偏好",
  "account.saveProfile": "保存档案",
  "account.addAddress": "添加地址",
  "account.label": "标签（家、办公室…）",
  "account.noGiftcards": "暂无礼品卡订单。",
  "account.commaHint": "用逗号分隔",
  "gift.title": "赠予一席难忘的盛宴",
  "gift.sub": "赠送私人主厨体验。收礼人将收到一张精美礼品卡，可用于任意预订。",
  "gift.amount": "金额（25 € – 1000 €）",
  "gift.recipientName": "收礼人姓名",
  "gift.recipientEmail": "收礼人邮箱",
  "gift.message": "祝福留言",
  "gift.buy": "购买礼品卡",
  "gift.note": "礼品卡码仅在付款确认后生成并通过邮件发送。",
  "becomeChef.title": "为最美的餐桌掌勺",
  "becomeChef.sub": "加入 Chef à Domicile 成为私人主厨。您的菜单、您的价格、您的日程——我们为您带来品味不凡的客户。",
  "becomeChef.cta": "申请成为主厨",
  "becomeChef.bio": "您的故事与烹饪经历",
  "becomeChef.years": "从业年数",
  "becomeChef.qualification": "资质 / 培训",
  "becomeChef.city": "城市",
  "becomeChef.cuisines": "擅长菜系",
  "becomeChef.success": "申请已收到。您的档案已进入专业认证流程——我们的团队将与您联系。",
  "becomeChef.s1t": "申请",
  "becomeChef.s1b": "告诉我们您的经验、培训与招牌菜系。",
  "becomeChef.s2t": "通过认证",
  "becomeChef.s2b": "身份、经验、厨房操作与作品集将接受专业审核。",
  "becomeChef.s3t": "烹饪与收益",
  "becomeChef.s3b": "接收高端客户的预订，安全收款。",
  "inquiry.contactTitle": "联系本馆",
  "inquiry.contactSub": "疑问、项目、特殊需求——礼宾团队将在 24 小时内回复。",
  "inquiry.corporateTitle": "企业体验",
  "inquiry.corporateSub": "高管晚宴、客户款待、团队庆典——彰显贵公司格调的美馔。",
  "inquiry.corporateCta": "预约企业体验",
  "inquiry.eventsTitle": "各种规模的活动",
  "inquiry.eventsSub": "生日、婚礼、酒会——从菜单设计到餐桌服务的完整美食呈现。",
  "inquiry.eventsCta": "策划我的活动",
  "inquiry.bespokeTitle": "全然定制的菜单",
  "inquiry.bespokeSub": "与您的主厨共同设计独一无二的菜单——围绕您的故事、您的食材、您的场合。",
  "inquiry.bespokeCta": "开启定制之旅",
  "inquiry.eventType": "活动类型",
  "inquiry.budget": "预算",
  "inquiry.location": "地点",
  "inquiry.company": "公司",
  "inquiry.phone": "电话",
  "inquiry.date": "期望日期",
  "inquiry.guests": "宾客",
  "inquiry.message": "您的留言",
  "inquiry.success": "谢谢您。礼宾团队将尽快与您联系。",
  "how.title": "如何运作",
  "how.sub": "从第一次点击到最后一道菜——四个乐章，从容不迫。",
  "how.s1t": "01 — 构想",
  "how.s1b": "选择城市、日期、宾客与菜系。浏览认证主厨及其招牌菜品。",
  "how.s2t": "02 — 预订",
  "how.s2b": "数分钟完成预订。价格按每位宾客透明计算——绝无隐藏费用。",
  "how.s3t": "03 — 迎接主厨",
  "how.s3b": "主厨携新鲜食材上门，在您的厨房烹饪，逐道上菜。",
  "how.s4t": "04 — 尽情享受",
  "how.s4b": "主厨离开时厨房一尘不染。您留下的是回忆——与赞美。",
  "about.title": "本馆",
  "about.p1": "Chef à Domicile 源于一个朴素的信念：世界上最难忘的餐厅，就是您的家。我们将品味不凡的主人与经认证的私人主厨相连，让餐厅化为五星级餐桌。",
  "about.p2": "从巴黎出发，我们的礼宾级市集甄选 28 种世界菜系的主厨——每位均经过身份、经验、厨房操作与作品集的专业认证。",
  "about.p3": "我们不是外卖。我们是款待之道——餐桌的艺术，回归家中。",
  "privateDining.title": "私人晚宴，臻于完美",
  "privateDining.sub": "2 至 20 位宾客的私密晚宴，由认证私人主厨精心编排。",
  "privateDining.p1": "与 Chef à Domicile 共度的夜晚，早在第一道菜之前便已开始。主厨与您共同设计菜单，甄选清晨最好的食材，将您的厨房化为高级餐厅的出菜口。",
  "privateDining.p2": "菜品逐道呈上餐桌——而您始终与宾客相伴。夜晚结束时，厨房洁净如初。",
  "privateDining.cta": "为我的晚宴寻找主厨",
  "faq.title": "常见问题",
  "faq.q1": "主厨如何认证？",
  "faq.a1": "每位主厨都需通过专业认证：身份核验（KYC）、职业经历、档案审核、厨房操作审核、菜品作品集、适用卫生文件与银行合规。仅认证主厨可上架市集。",
  "faq.q2": "每位宾客的价格包含什么？",
  "faq.a2": "主厨采买、备餐、烹饪、菜单的餐桌服务及厨房清洁。总价由我们的服务在预订时透明计算。",
  "faq.q3": "菜单能否适应过敏或饮食偏好？",
  "faq.a3": "可以。在饮食档案中保存过敏原与偏好，并在预订时添加特殊要求——主厨会相应调整菜单。",
  "faq.q4": "如何付款？",
  "faq.a4": "付款由 Stripe 安全处理。仅在预订确认后扣款；礼品卡与优惠码可在结账前使用。",
  "faq.q5": "可以取消预订吗？",
  "faq.a5": "可以，在您的账户中操作。具体条款请参阅取消政策。",
  "journal.title": "美食志",
  "journal.sub": "美食、待客与餐桌艺术——来自 Chef à Domicile。",
  "journal.empty": "新的故事正在书写。敬请期待。",
  "journal.related": "相关故事",
  "legal.termsTitle": "服务条款",
  "legal.privacyTitle": "隐私政策",
  "legal.cancelTitle": "取消政策",
  "legal.terms1": "Chef à Domicile 运营连接客户与独立认证私人主厨的平台。使用 chef-adomicile.com 即表示您接受本条款。预订构成客户与主厨之间的合约，由平台促成。",
  "legal.terms2": "价格按每位宾客展示；最终总价由我们的服务在预订时计算。付款由安全支付伙伴处理。主厨为独立专业人士，对所提供的餐饮服务负责。",
  "legal.terms3": "本站所有内容、品牌与图片均归 Chef à Domicile 所有。滥用平台可能导致账户被暂停。",
  "legal.privacy1": "我们仅收集账户与预订所需的数据：身份、联系方式、地址、饮食偏好与历史记录。绝不出售您的数据。",
  "legal.privacy2": "支付数据仅由支付伙伴处理；Chef à Domicile 绝不存储卡号。",
  "legal.privacy3": "您可随时通过联系页面申请访问、更正或删除个人数据。",
  "legal.cancel1": "您可在账户中取消预订。提前足够时间取消的订单将按预订时告知的条款退款。",
  "legal.cancel2": "临近取消可能产生费用，因主厨已采买食材并预留档期。礼品卡付款将退回卡内。",
  "legal.cancel3": "若主厨需要取消，礼宾团队将为您安排同级认证主厨或全额退款，由您选择。",
  "footer.tag": "非凡美馔。尽在府上。",
  "footer.explore": "探索",
  "footer.company": "本馆",
  "footer.legal": "法律",
  "footer.rights": "© 2026 Chef à Domicile — Tous droits réservés / All rights reserved",
  "seo.homeTitle": "Chef à Domicile — 上门私人主厨 | 奢华私人晚宴",
  "seo.homeDesc": "预订经认证的私人主厨，在家享受非凡晚宴。巴黎及更多城市的奢华私人餐饮——定制菜单、活动、企业体验。",
};
export default zh;
